import { find } from 'lodash-es';


const getPage = (pages, label) => {
  return find(pages, { label });
};

export default getPage;
